
/* injects from baggage-loader */

'use strict';
import { trophies } from '_appRoot/index.const';
import { 
    html_daily_board, 
    peixeboi_apresentation,
    tamandua_apresentation,
    onca_apresentation,
    macaco_apresentation } from './main.const';

// ident
import { assign, cloneDeep } from  'lodash';

export default class MainController {
    constructor($log, $state, $rootScope, $timeout, Session, Dialog, Trophies) {
        'ngInject';
        this.$log = $log;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.Session = Session;
        this.Dialog = Dialog;
        this.Trophies = Trophies;
        this.feedbackFinishStage = ["Você possui o <b>distintivo completo</b> e é um <b>Guardião da natureza</b>!"];
    }

    $onInit(){
        let { stages, user } = this.Session.get();

        this.stages = stages;

        this.trophies = {
            default: this.Trophies.getThrophies().default.map(mapInsignies),
            emblem: this.Trophies.getThrophies().emblem.map(mapEmblems)
        }

        this.trophiesCollected = cloneDeep(this.trophies.emblem);

        if(this.trophies.emblem[4].collected){
            for(let i = 0; i<this.trophiesCollected.length-1; i++){
                this.trophiesCollected[i].collected = false;
                this.$log.log(this.trophiesCollected);
            }
        }        

        if(!this.trophies.emblem[4].collected && this.trophies.emblem[0].collected && this.trophies.emblem[1].collected && this.trophies.emblem[2].collected && this.trophies.emblem[3].collected){
            let qUpdate = this.Session.get();
            qUpdate.trophies.emblem[4].collected = true;



            this.Session.save(qUpdate);
        }

        if (!this.stages) return false;

        this.$timeout(() => {
            if(user.daily_board) this.Dialog.showAlert('label-alert', html_daily_board);
            this.Session.updateUser({ daily_board: false });
        }, 1200);
    }

    openDaily(){
        this.Dialog.showDaily('label-daily',() => false);
    }

    openHelp(){
        this.Dialog.showAlert('label-alert', html_daily_board);        
    }

    toOnca(){
        this.Dialog.showOnca(onca_apresentation, () => {
            this.$timeout( () => this.$state.go('main.stage-two'), 600);
        });
    }

    toMacaco(){
        this.Dialog.showMacaco(macaco_apresentation, () => {
            this.$timeout( () => this.$state.go('main.stage-three'), 600);
        });
    }

    toTamandua(){
        this.Dialog.showTamandua(tamandua_apresentation, () => {
            this.$timeout( () => this.$state.go('main.stage-four'), 600);
        });
    }

    toPeixeBoi(){
        this.Dialog.showPeixeboi(peixeboi_apresentation, () => {
            this.$timeout(() => this.$state.go('main.stage-one'), 600);
        });
    }

    showEndGame(){
        this.$log.log("here!");
        this.$log.log(this.Trophies.getCollectThrophies().length)
        if(this.Trophies.getCollectThrophies().length>3)
            this.Dialog.showTrophy('completo', this.feedbackFinishStage);
    }
}

function mapEmblems(emblem){
    return assign(emblem, { img: trophies.emblem[emblem.name] });
}

function mapInsignies(insignie){
    return assign(insignie, { img: trophies.default[insignie.name] });
}


// WEBPACK FOOTER //
// ./src/app/pages/main/main.controller.js